import { GET_AVAILABLE_USERS } from '../types'

const initialState = {
  supervisorGroups: [],
  availableGroups: [],
  availableUsers: [],
  availableTemplates: []
}

export default function (state = initialState, action) {
  switch (action.type) {
    // case GET_SUPERVISOR_GROUPS: return {
    //   ...state,
    //   supervisorGroups: action.payload
    // }
    case GET_AVAILABLE_USERS: return {
      ...state,
      availableUsers: action.payload.supervisors,
      availableGroups: action.payload.groups,
      availableTemplates: action.payload.templates
    }
    default: return { ...state }
  }
}
